export default class QRCode {

  id = null;

  name = "";
  customer = null;
  customerName = "";
  code = "";

  facility = null;
  facilityName = "";

  constructor() {
  }
}
